export const DEFAULT_INVITE_WORKSPACE_MESSAGE =
  'You have been invited to a new workspace.';

export const DEFAULT_INVITE_SHARE_MESSAGE =
  'You have been invited to a new share.';
